import React, { useEffect, useMemo, useState } from 'react'
import CustomizedDialogs from '../../../common/CustomizedDialogs'
import { Box, Checkbox, Divider, FormControlLabel, Radio, Typography } from '@mui/material'
import '../../../style/modal/TicketDetails.scss'
import TextBox from '../../../common/TextBox'
import MButton from '../../../common/MButton'
import moment from 'moment'
import { generateChecksum, generateCommission, transferArrToObject } from '../../../utils/helpers'
import { useDispatch, useSelector } from 'react-redux'
import { checkBeneficiaryStatus, generateQROrders, getBBTPaymentConfig, getBookingsCancelV2, updateBookingsModify } from '../../../redux/Booking/BookingActions'
import { showErrorAlert, showSuccessAlert, updateLoadingScreen } from '../../../redux/Actions'
import AlertModalForSuccessPrint from '../../../common/AlertModalBkgPrint'
import ConfirmModal from '../../../common/ConfirmModal'
import { handleConfirmFare } from '../../Booking/constant'
import DynamicQR from '../DynamicQR'
const TicketDetails = (props) => {
    const { id = 0, open = false, data = {}, titleText = '', onClose = () => { }, handleResetTrip = () => { },
        filterOpt = {},
        bkgDeatails = {}
    } = props
    const dispatch = useDispatch();
    const store = useSelector((store) => store);
    const { user } = store;
    const { userDetails } = user;
    let ticketDetails = data?.Table?.[0] || {}
    const [selSeat, setSelSeat] = useState([])
    const [remark, setRemark] = useState(ticketDetails?.Remarks || '')
    const [openModal, setOpenModal] = useState({
        id: 0,
        open: false,
        isFullCancel: false,
        data: {},
        msg: '',
    })
    const [filterValue, setFilterValue] = useState(id === 3 ? 1 : 0)
    let seat = useMemo(() => {
        return (data?.Table1 || []).map((obj) => ({ seatNo: obj.SeatNo, check: 1 }))
    }, [data?.Table1 || []])

    let checkSeat = useMemo(() => {
        return selSeat.filter((obj) => obj.check === 1)
    }, [selSeat])
    useEffect(() => {
        setSelSeat(seat)
    }, [seat])







    const ticketDetailsCol = [
        { label: "PNR", value: ticketDetails?.BookingID || '' },
        { label: "Ticket No.", value: ticketDetails?.TicketNo || '' },
        { label: "Status", value: "CONFIRMED" },
        { label: "Type", value: ticketDetails?.BookingType === 'AP' ? 'Phone' : ticketDetails?.BookingType === 'AC' ? 'Confirm' : '' },
        { label: "Operator", value: ticketDetails?.OperatorName || '' },
        { label: "Total Fare", value: Number(ticketDetails?.TotalFare || 0) + Number(ticketDetails?.ServiceTax || 0) },
        { label: "PAX Name", value: ticketDetails?.PassengerName || '' },
        { label: "Phone", value: ticketDetails?.PassengerContactNo1 || '' },
        {
            label: "Seats",
            value: seat
        },
        { label: "Trip", value: ticketDetails?.TripName || '' },
        { label: "Route", value: ticketDetails?.SubRouteName || '' },
        { label: "Journey Date", value: moment(ticketDetails?.JourneyDate).format("ddd, DD-MMM-YYYY") },
        { label: "Booking Date", value: moment(ticketDetails?.BookingDate).format("ddd, DD-MMM-YYYY") },
        { label: "Booked By", value: ticketDetails?.BookedBY || '' },
        { label: "Remarks", value: ticketDetails?.Remarks || '' }
    ];


    const handleConfirmBkg = (orderID = 0, pgTaxId = '') => {
        let seatObj = transferArrToObject(data?.Table1 || [])
        let baseTotal = data?.Table1?.reduce(
            (sum, obj) => sum + Number(obj?.Fare || 0),
            0
        ) || 0;
        const body = {
            intBookingID: ticketDetails?.BookingID || 0,
            intModificationType: 6,
            intNewTripID: 0,
            strOldSeats: '',
            strNewSeats: seatObj.SeatNo || '',
            strNewFares: seatObj?.Fare || '',
            dtNewJDate: '0001-01-01',
            intFromCityId: 0,
            intToCityID: 0,
            dcmSeaterLow: 0,
            dcmSeaterHigh: 0,
            dcmSleeperLow: 0,
            dcmSleeperHigh: 0,
            dcmSlumberLow: 0,
            dcmSlumberHigh: 0,
            dcmTotalFare: baseTotal || 0,
            intPickupID: ticketDetails?.PickupID || 0,
            intDropoffID: ticketDetails?.DropoffID || 0,
            strPassengerName: ticketDetails?.PassengerName || '',
            intUserID: 0,
            intAgentID: userDetails?.AgentID || 0,
            intBranchID: 0,
            intBranchUserID: 0,
            strTicketNo: ticketDetails?.TicketNo || '',
            strPhone1: ticketDetails?.PassengerContactNo1 || '',
            strPhone2: ticketDetails?.PassengerContactNo2 || '',
            intPayModeID: filterOpt?.allPaymentMode?.[0].id || 1,
            intSwipeIssuerID: 0,
            strCardNo: '',
            intAgentUserID: userDetails?.AgentUserID || 0,
            intGuestTypeID: 0,
            strEmailID: '',
            strRemarks: remark,
            dcmlRoundOffFare: 0,
            qrOrderId: orderID,
            strpgtxnid: pgTaxId,
            paymentMode: filterOpt?.allPaymentMode?.[0].key || 'cash',
        }
        dispatch(updateBookingsModify(body)).then((res) => {
            if (res.data.status) {
                setOpenModal((prev) => ({
                    ...prev,
                    id: 2,
                    open: true,
                    isFullCancel: false,
                    data: res.data.Data,
                    msg: <>Booking <span style={{ color: '#ff7100', fontWeight: 'bold' }}>{res.data.Data}</span> Done Successfully!</>,
                }))

            } else {
                dispatch(showErrorAlert(res.data.Message))
            }
        })
    }


    const handleBkg = () => {
        let paymentMode = filterOpt?.allPaymentMode || []
        if (paymentMode?.[0]?.id === 2) {
            generateQRCode()
        } else {
            handleConfirmBkg()
        }
    }
    const generateQRCode = () => {

        const beneficiaryStatusBody = {
            intCompanyID: bkgDeatails?.tripCompanyID || 0,
            intPaymentProductTypeID: 1,
            intBusinessVerticalID: 1,
        }

        dispatch(checkBeneficiaryStatus(beneficiaryStatusBody)).then((res) => {
            if (res?.data?.status) {
                let resParse = JSON.parse(res?.data?.Data || '{}')?.Table?.[0] || {}
                if (resParse?.IsActive === 1) {
                    getPaymentConfig(resParse)
                } else {
                    dispatch(updateLoadingScreen(false));
                    dispatch(showErrorAlert(`QR Dynamic is Not Enable This Trip. Company Name : ${bkgDeatails?.tripDetails?.CompanyName} (${bkgDeatails?.tripDetails?.CompanyID})`))
                }
            } else {
                dispatch(updateLoadingScreen(false));
                dispatch(showErrorAlert(res?.data?.Message))
            }
        })
    }

    const getPaymentConfig = (resParse) => {
        let tripTotalAmt = handleConfirmFare(data?.Table1 || [])
        const payConfigBody = {
            intCompanyID: bkgDeatails?.tripCompanyID,
            intAgentID: userDetails?.AgentID || 0,
            intTripID: bkgDeatails?.tripDetails.TripID,
            intFromCityID: bkgDeatails?.tripDetails.FromCityID,
            intToCityID: bkgDeatails?.tripDetails.ToCityID,
            intFareSeater: tripTotalAmt?.seaterCount > 0 ? tripTotalAmt?.seaterAmt : 0,
            intFareSlpr: tripTotalAmt?.sleeperCount > 0 ? tripTotalAmt?.sleeperAmt : 0,
            intFareSlm: tripTotalAmt?.sleeperCount > 0 ? tripTotalAmt?.slumperAmt : 0,
        }
        dispatch(getBBTPaymentConfig(payConfigBody)).then((res) => {
            if (res?.data?.status) {
                let commAmt = JSON.parse(res.data.Data || '{}')?.Table1?.[0] || {}
                handleQROrders(resParse, commAmt, tripTotalAmt)
            } else {
                dispatch(showErrorAlert(res?.data.Message))
            }
        })

    }

    const handleQROrders = (data, commAmt, tripTotalAmt = {}) => {
        let transferfee = data?.TransactionFeePer || 0
        let amount = generateCommission({ ...tripTotalAmt, grandAmt: Number(ticketDetails?.TotalFare || 0) + Number(ticketDetails?.ServiceTax || 0) }, commAmt, transferfee, commAmt)
        let transferFeeAmount = Math.round(((amount * Number(transferfee || 0)) / 100) * 100) / 100

        let body = {
            agentid: userDetails?.AgentID,
            agentuserid: userDetails?.AgentUserID,
            amount: Number(amount).toFixed(2),
            application: 'crs',
            branchid: 0,
            branchuserid: 0,
            companyid: bkgDeatails?.tripCompanyID || 0,
            deviceid: '',
            devicetype: 'web',
            paymentmethod: 'qr',
            tag1: 'bbt_booking',
            tag2: '',
            vertical: 'bus',
            transferfee: transferFeeAmount,
            checksum: '',
        }
        let checksum = generateChecksum(body)
        let crsCallback = `http://crsapi.bookbustickets.com/service.svc/BBTAppQrBkgDetailsInsertUpdate?intorderid=_OrderID_&decamount=${Number(amount)}&decpgcharge=${0}&decpgamount=${Number(amount)}&strstatus=${`PAYMENT_INITIATED`}&strmerchanttxnid=_MTxnID_&strpgtxnid=&dtstatustime=${moment().format('YYYY-MM-DD HH:mm:ss')}&intcompanyid=${bkgDeatails?.tripCompanyID || 0}&intentityid=${userDetails.AgentID}&strentitytype=A&BusinessVerticleId=1&paymentproducttypeid=9&entityPaymentid=0&userid=${userDetails.AgentUserID}&qrUTRNumber=&RechargeStatus=${`QR Generated`}&transferfee=${transferFeeAmount}&strpgname=&mobileno=${bkgDeatails?.phoneNumber || ''}&intbranchid=0&refStatus=&refStatusTime=${`01-01-0001 00:00:00`}&refUserID=${0}`
        dispatch(generateQROrders({
            ...body, checksum,
            extraInfo: {
                CrsCallback: crsCallback
            }
        })).then((res) => {
            dispatch(updateLoadingScreen(false));
            if (res?.data?.isSuccess) {
                setOpenModal((prev) => ({
                    ...prev,
                    id: 3,
                    open: true,
                    data: res?.data?.data,
                    msg: '',
                    isFullCancel: false,
                }))
            } else {
                dispatch(showErrorAlert(res?.data?.error || 'Error in Generating QR Code'))
            }
        }).catch((error) => {
            dispatch(updateLoadingScreen(false));
            dispatch(showErrorAlert('Error in Generating QR Code'))
        });

    }


    const handleCancelDetails = (isFullCancel = false) => {
        if (!(isFullCancel) && checkSeat.length === 0) {
            dispatch(showErrorAlert('Select Cancel Seat'))
            return
        }
        const body = {
            intUserID: 0,
            intBookingID: ticketDetails?.BookingID || 0,
            blnConfirmCancel: false,
            intUserIDFor: 0,
            strSeatNos: isFullCancel ? seat.map((obj) => obj.seatNo).join(',') : checkSeat.map((obj) => obj.seatNo).join(','),
            blnIsFullRefund: false,
            intAgentUserID: userDetails?.AgentUserID || 0,
            dtCancelDate: '0001-01-01',
            intForceCancelDate: 0,
            strRemarks: remark || '',
            dcmCancellationEarned: 0,
            blnForceCanclPct: false,
            CancPctInp: 0,
            intLogID: 0,
            blnIsAgentTicketRefund: false,
            intCancellationLedgerId: 0,
        }
        dispatch(getBookingsCancelV2(body)).then((res) => {
            if (res.data.status) {
                let parseData = JSON.parse(res.data.Data || "{}").Table?.[0] || {}
                if (parseData.ErrMsg !== null) {
                    dispatch(showErrorAlert(parseData.ErrMsg))
                    return
                }
                setOpenModal((prev) => ({
                    ...prev,
                    id: 1,
                    open: true,
                    isFullCancel: isFullCancel,
                    msg: <>Are you sure you want to {isFullCancel ? 'Full' : 'Partial'} Cancel Booking <span style={{ color: '#ff7100', fontWeight: 'bold' }}>{ticketDetails?.BookingID || ''}</span> and refund amount <span style={{ color: '#ff7100', fontWeight: 'bold' }}>{Number(parseData.RefundAmountCurrent || 0).toFixed(2)}</span></>,
                }))
            } else {
                dispatch(showErrorAlert(res.data.Message))
            }
        })

    }


    const handleCancel = (isFullCancel = false) => {
        if (!(isFullCancel) && checkSeat.length === 0) {
            dispatch(showErrorAlert('Select Seat'))
            return;
        }
        const body = {
            intUserID: 0,
            intBookingID: ticketDetails?.BookingID || 0,
            blnConfirmCancel: true,
            intUserIDFor: 0,
            strSeatNos: isFullCancel ? seat.map((obj) => obj.seatNo).join(',') : checkSeat.map((obj) => obj.seatNo).join(','),
            blnIsFullRefund: false,
            intAgentUserID: userDetails?.AgentUserID || 0,
            dtCancelDate: '0001-01-01',
            intForceCancelDate: 0,
            strRemarks: remark || '',
            dcmCancellationEarned: 0,
            blnForceCanclPct: false,
            CancPctInp: 0,
            intLogID: 0,
            blnIsAgentTicketRefund: false,
            intCancellationLedgerId: 0,
        }
        dispatch(getBookingsCancelV2(body)).then((res) => {
            if (res.data.status) {
                let parseData = JSON.parse(res.data.Data || "{}").Table?.[0] || {}
                let parseData1 = JSON.parse(res.data.Data || "{}")?.Table1 || []


                let refundAmt = parseData.RefundAmountCurrent || 0

                if (parseData1?.length !== 0) {
                    refundAmt = parseData1?.[0].RefundAmountCurrent || 0
                }
                if (parseData.ErrMsg !== null && parseData?.ErrMsg !== undefined) {
                    dispatch(showErrorAlert(parseData.ErrMsg))
                    return
                }
                handleResetTrip()
                dispatch(showSuccessAlert(`SuccessFully Cancel. Refund Amount ${Number(refundAmt || 0).toFixed(2)}`))
                onClose()
            } else {
                dispatch(showErrorAlert(res.data.Message))
            }
        })
    }
    const handleClose = () => {
        setOpenModal((prev) => ({
            ...prev,
            id: 0,
            open: false,
            isFullCancel: false,
            data: {},
            msg: '',
        }))
    }


    const handlePrint = (data) => {
        window.open(`http://bookbustickets.com/PrintTicket_Agent.aspx?bkgID=${data}&pnr=${data}&uid=${userDetails.AgentUserID}&utype=A`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes')
        handleResetTrip()
        onClose()

    }
    return (
        <>
            <CustomizedDialogs
                open={open}
                titleText={titleText}
                width={'550px'}
                height={'auto'}
                onClose={onClose}
                padding={'0px'}
            >
                <Box className='ticketDetails_page scrollBlueV8'
                    sx={{
                        maxHeight: '83vh',
                        overflowY: 'auto',
                    }}
                >
                    <Box className='details_Section'>
                        {id !== 1 &&
                            <Box sx={{ display: 'flex', paddingBottom: '6px', gap: '10px' }}>
                                <FormControlLabel
                                    className='details_label'
                                    control={
                                        <Radio
                                            checked={filterValue === 0}
                                            sx={{
                                                '&.Mui-checked': {
                                                    color: '#0086FF',
                                                },
                                                padding: '0px',
                                                paddingLeft: '10px',
                                                marginRight: '6px',
                                            }}
                                            onChange={(e) => {
                                                setFilterValue(0)
                                                setSelSeat(seat)
                                            }}
                                        />
                                    }
                                    label='All Seats'
                                />
                                <FormControlLabel
                                    className='details_label'
                                    control={
                                        <Radio
                                            checked={filterValue === 1}
                                            sx={{
                                                '&.Mui-checked': {
                                                    color: '#0086FF',
                                                },
                                                padding: '0px',
                                                paddingLeft: '10px',
                                                marginRight: '6px',
                                            }}
                                            onChange={(e) => {
                                                setFilterValue(1)
                                            }}
                                        />
                                    }
                                    label='Some Seats'
                                />
                            </Box>
                        }
                        {ticketDetailsCol.map((obj) => (
                            <Box className='details_row'>
                                <Typography className='details_label' sx={{ minWidth: '30%' }}>{obj.label}</Typography>
                                <Typography>:</Typography>
                                {obj.label === 'Remarks' ?
                                    <Box width={'100%'}>
                                        <TextBox value={remark} onChange={(event) => {
                                            setRemark(event.target.value)
                                        }} />
                                    </Box> :
                                    obj.label === 'Seats' ?
                                        <Box className='seat-box'>
                                            {selSeat.map((item, index) => (
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', width: '60px' }} key={index}>
                                                    <Checkbox checked={item.check === 1} disabled={filterValue === 0}
                                                        onChange={(event) => {
                                                            const updatedSeats = selSeat.map((seat, i) =>
                                                                i === index
                                                                    ? { ...seat, check: event.target.checked ? 1 : 0 }
                                                                    : seat
                                                            );
                                                            setSelSeat(updatedSeats);
                                                        }}

                                                    />
                                                    <Typography className='details_value'>{item.seatNo}</Typography>
                                                </Box>
                                            ))}
                                        </Box>
                                        : <Typography className='details_value'>{obj.value}</Typography>
                                }
                            </Box>
                        ))}
                    </Box>
                    <Divider sx={{ borderColor: '#00000033' }} />
                    <Box className='details_btn_section'>
                        <MButton className='btn-orange-outline btnFullwidth' variant={'outlined'} btnName='Close' onClick={onClose} />
                        {(id === 0 || id === 1) && <MButton className='btn-orange btnFullwidth btnWarpText' btnName='Phone to confirm' disabled={!(data.confirmRole) || filterValue === 1} onClick={handleBkg} style={{ width: '100% !important' }} />}
                        {(id === 0 || id === 2 || id === 3) && <MButton className='btn-orange btnFullwidth' btnName='Cancel'
                            disabled={!data.cancelRole}
                            style={{ minWidth: '100% !important' }} onClick={() => {
                                handleCancelDetails(filterValue === 0)
                            }} />
                        }
                    </Box>
                </Box>
            </CustomizedDialogs>
            {openModal?.open &&
                <>
                    {openModal.id === 1 &&
                        <ConfirmModal open={openModal.id === 1} onClose={(val) => {
                            if (val) {
                                handleCancel(openModal.isFullCancel)
                            }
                            handleClose()
                        }}

                            dialogConfirmationMessage={openModal.msg}
                        />
                    }
                    {openModal.id === 2 &&
                        <AlertModalForSuccessPrint open={openModal.id === 2}
                            onClose={() => {
                                handleResetTrip()
                                onClose()
                            }}
                            onConfirm={() => {
                                handlePrint(openModal.data)
                            }}
                            message={openModal.msg}
                        />
                    }
                    {openModal.id === 3 &&
                        <DynamicQR open={openModal.id === 3}
                            bkgDetails={{ ...bkgDeatails, phoneNumber: ticketDetails?.PassengerContactNo1 }}
                            onClose={handleClose}
                            data={openModal.data}
                            handlePaymentSuccess={(orderID = 0, pgTaxId = '') => {
                                handleConfirmBkg(orderID, pgTaxId)
                            }}
                        />
                    }
                </>
            }
        </>
    )
}

export default TicketDetails